export const INDUSTRY_CODES = [
    "FIN_SERVICES",
    "INSURANCE",
    "TECH_SAAS",
    "HEALTH_PHARMA",
    "ENERGY_UTILITIES",
    "MANUFACTURING",
    "RETAIL_ECOMMERCE",
    "TRANSPORT_LOGISTICS",
    "TELECOM",
    "REAL_ESTATE_CONSTRUCTION",
    "MEDIA_ENTERTAINMENT",
    "EDUCATION",
    "PUBLIC_SECTOR",
    "NGO_INTERNATIONAL",
    "AGRI_FOOD",
    "HOSPITALITY_TOURISM",
    "PROF_SERVICES",
    "OTHER",
];

export const USE_CASE_CODES = [
    "DRAFTING",
    "PRE_SIGNATURE_REVIEW",
    "NEGOTIATION",
    "DUE_DILIGENCE",
    "COMPLIANCE_AUDIT",
    "RENEWAL",
    "AMENDMENT",
    "POST_SIGNATURE_OBLIGATIONS",
    "VENDOR_RISK",
    "DISPUTE_LITIGATION",
    "TERMINATION_EXIT",
    "ARCHIVING_GOVERNANCE",
];

export const ROLE_CODES = [
    "SELLER",
    "SUBCONTRACTOR",
    "BUSINESS_PARTNER",
    "INVESTOR",
    "DISCLOSER",
    "RECIPIENT",
    "CLIENT",
    "BUYER",
    "PROVIDER",
    "BOTH_PARTIES",
    "LANDLORD",
    "TENANT",
    "CONSULTANT",
    "EMPLOYER",
    "EMPLOYEE",
    "LICENSOR",
    "LICENSEE",
    "ASSIGNOR",
    "ASSIGNEE",
    "DATA_CONTROLLER",
    "DATA_PROCESSOR",
    "DATA_RECIPIENT",
    "LENDER",
    "BORROWER",
    "GUARANTOR",
    "BENEFICIARY",
    "FRANCHISOR",
    "FRANCHISEE",
    "DISTRIBUTOR",
    "RESELLER",
    "AGENT",
    "PRINCIPAL",
    "COMPANY",
    "SHAREHOLDER",
    "ENTREPRENEUR",
    "ACQUIRER",
    "TARGET",
    "SELLING_SHAREHOLDER",
    "PUBLIC_AUTHORITY",
    "CONTRACTING_AUTHORITY",
    "OTHER",
];

export const CORE_ROLE_CODES = [
    "PROVIDER",
    "CLIENT",
    "BUYER",
    "SELLER",
    "LANDLORD",
    "TENANT",
    "DATA_CONTROLLER",
    "DATA_PROCESSOR",
    "DISCLOSER",
    "RECIPIENT",
    "OTHER",
];

export const DOCUMENT_TYPE_CODES = [
    "NDA",
    "MSA",
    "SOW",
    "SAAS",
    "SOFTWARE_LICENSE",
    "SERVICE_AGREEMENT",
    "CONSULTING",
    "SUBCONTRACTING",
    "DPA",
    "DATA_SHARING",
    "SALE_PURCHASE",
    "SUPPLY",
    "DISTRIBUTION",
    "RESELLER",
    "AGENCY",
    "FRANCHISE",
    "LEASE",
    "LOI_TERM_SHEET",
    "SHAREHOLDERS",
    "INVESTMENT",
    "SHARE_PURCHASE",
    "ASSET_PURCHASE",
    "JOINT_VENTURE",
    "PARTNERSHIP",
    "LOAN_CREDIT",
    "GUARANTEE",
    "SECURITY_AGREEMENT",
    "IP_ASSIGNMENT",
    "LICENSE_IP",
    "EMPLOYMENT",
    "AMENDMENT",
    "ADDENDUM",
    "WAIVER",
    "TERMINATION",
    "SETTLEMENT",
    "RELEASE",
    "POWER_OF_ATTORNEY",
    "MANDATE",
    "BOARD_RESOLUTION",
    "CORPORATE_APPROVAL",
    "COMPLIANCE_POLICY",
    "PUBLIC_PROCUREMENT",
    "GRANT_AGREEMENT",
    "INSURANCE_POLICY",
    "POLICY",
    "OTHER",
];

export const customStyles = {
    primaryButton: {
        backgroundColor: 'var(--color-primary)',
        borderColor: 'var(--color-primary)',
        color: 'white'
    },
    primaryButtonHover: {
        backgroundColor: 'var(--color-primary-hover)',
        borderColor: 'var(--color-primary-hover)'
    },
    secondaryCard: {
        backgroundColor: 'var(--color-secondary-bg)',
        border: `1px solid var(--color-secondary-border)`
    },
    primarySection: {
        backgroundColor: 'var(--color-secondary-bg)',
        border: `1px solid var(--color-secondary-border)`
    },
    infoAlert: {
        backgroundColor: '#E6F4FF',
        border: '1px solid var(--color-secondary-light)'
    },
    successTag: {
        backgroundColor: '#F6FFED',
        border: '1px solid #52C41A',
        color: '#52C41A'
    },
    primaryTag: {
        backgroundColor: '#E6F4FF',
        border: '1px solid var(--color-primary)',
        color: 'var(--color-primary)'
    }
};

export const initialState = {
    id: null,
    type_analyse: null,
    title: '',
    context: 'RENEWAL',
    main_document: {
        id:null,
        type: 'principal',
        title: '',
        party_role: '',
        description: '',
        industry: [],
        jurisdiction: [],
        content_html: "",
        comments: []
    },
    amendments: [],
    reference_file_ids: []
};
